import { render, staticRenderFns } from "./MonitoringCapas.vue?vue&type=template&id=2d149e2a&scoped=true"
import script from "./MonitoringCapas.vue?vue&type=script&lang=js"
export * from "./MonitoringCapas.vue?vue&type=script&lang=js"
import style0 from "./MonitoringCapas.vue?vue&type=style&index=0&id=2d149e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d149e2a",
  null
  
)

export default component.exports